import { render } from "./ProductTile.vue?vue&type=template&id=2789140e&scoped=true"
import script from "./ProductTile.vue?vue&type=script&lang=js"
export * from "./ProductTile.vue?vue&type=script&lang=js"

import "./ProductTile.vue?vue&type=style&index=0&id=2789140e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2789140e"]])

export default __exports__